import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Block from '../Block';
import get from 'lodash/get';
import { Date } from '../Format';
import VersionBlock from './general/VersionBlock';
import InfoContainer from './general/InfoContainer';
import HistoryEnabled from './general/HistoryEnabled';
import HistoryLocationStatus from './general/HistoryLocationStatus';
import HistoryLocationAuthorization from './general/HistoryLocationAuthorization';
import HistorySptConsent from './general/HistorySptConsent';
import HistoryMediaConsent from './general/HistoryMediaConsent';
import HistoryDataConsent from './general/HistoryDataConsent';

const PublisherGeneralDevice = ({device}) => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col>
          <Block title={t("devices.general")}>
            <Row>
              <InfoContainer label={t("devices.idfa")} value={device.idfa} />
              <InfoContainer label={t("devices.app")} value={get(device, 'app.name', '-')} />
              <InfoContainer
                label={t("devices.createdAt")}
                value={<Date date={device.created_at} dateFormat='long' defaultValue='-'/>}
              />
              <InfoContainer
                label={t("devices.updatedAt")}
                value={<Date date={device.updated_at} dateFormat='long' defaultValue='-'/>}
              />
              <InfoContainer label={t("devices.appVersion")} value={device.app_version} />
              <InfoContainer label={t("devices.sdkVersion")} value={device.sdk_version} />
              <InfoContainer label={t("devices.locationStatus")} value={device.location_status} />
              <InfoContainer label={t("devices.locationAutorized")} value={JSON.stringify(device.location_aurhorized)} />
              <InfoContainer label={t("devices.locationMode")} value={device.location_mode} />
              <InfoContainer label={t("devices.deviceModel")} value={device.device_model} />
              <InfoContainer label={t("devices.systemVersion")} value={device.system_version} />
              <InfoContainer label={t("devices.lang")} value={device.lang} />
              <InfoContainer label={t("devices.backgroundLocationEnabled")} value={JSON.stringify(device.background_location_enabled)} />
              <InfoContainer label={t("devices.adTracking")} value={device.ad_tracking} />
              <InfoContainer label={t("devices.cmp")} value={get(device, 'cmp.name', '-')} />
              <InfoContainer label={t("devices.cmpMode")} value={device.cmp_mode} />
              <InfoContainer label={t("devices.sptVendorConsent")} value={device.spt_consent} />
              <InfoContainer label={t("devices.geomediaConsent")} value={device.media_consent} />
              <InfoContainer label={t("devices.geoDataConsent")} value={device.data_consent} />
            </Row>
            <Row>
              <InfoContainer label={t("devices.iabConsentString")} size={12} value={device.iab_consent_string} />
            </Row>
          </Block>
        </Col>
      </Row>
      <Row>
        <Col>
          <HistoryEnabled device={device}/>
        </Col>
        <Col>
          <HistoryLocationStatus device={device}/>
        </Col>
        <Col>
          <HistoryLocationAuthorization device={device}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <HistorySptConsent device={device}/>
        </Col>
        <Col>
          <HistoryMediaConsent device={device}/>
        </Col>
        <Col>
          <HistoryDataConsent device={device}/>
       </Col>
      </Row>
      <Row>
        <Col>
          <VersionBlock data={device.versions}/>
        </Col>
     </Row>
    </>
  )
}

export default PublisherGeneralDevice
